module.exports = __webpack_public_path__ + "static/media/logo.b51b4a11.png";